module.exports = __webpack_public_path__ + "static/media/confettiDesktop.97dcf809.svg";